import React from 'react'

import { Link, Stack, Typography } from '@mui/material'

import { ALL_LEGAL_DOCUMENTS, LEGAL_DOCUMENTS } from '@/utils/legal'

import { LegalLinksProps } from './types'

const LegalLinks: React.FC<LegalLinksProps> = ({ justifyContent = 'center' }) => {
  return (
    <Stack direction="row" spacing={2} justifyContent={justifyContent} flexWrap="wrap">
      {ALL_LEGAL_DOCUMENTS.map(document => (
        <Typography key={document} variant="body2" fontSize="0.75rem" color="text.secondary">
          <Link
            href={LEGAL_DOCUMENTS[document].url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
          >
            {LEGAL_DOCUMENTS[document].label}
          </Link>
        </Typography>
      ))}
    </Stack>
  )
}

export default LegalLinks
